import routes from './routes'
import {createRouter, createWebHistory} from "vue-router";
import store from '../store/index'

const isProduction = process.env.NODE_ENV === 'production';

// 3. 创建路由实例并传递 `routes` 配置
// 你可以在这里输入更多的配置，但我们在这里
// 暂时保持简单
const router = createRouter({
  history: createWebHistory(isProduction ? '/customerui/' : '/'),
  routes
})

router.beforeEach((to, from, next) => {
  if (document.documentElement.clientWidth <= 600) {
    store.commit('CLOSE_SLIDEBAR')
  }
  var uid = localStorage.getItem("uid");
  var token = localStorage.getItem("utn");
  var firstLogin = localStorage.getItem("firstLogin");
  if ( to.path == '/login') {
    if ( uid && token ) {
      if (firstLogin === 'true') {
        next({path:'/firstLogin'})
      } else {
        next({path:'/'})
      }
    }
    next();
  } else if (to.path == '/firstLogin') {
    if ( uid && token ) {
      next();
    } else {
      next({path:'/'})
    }
  } else {
    if (to.meta.requiresAuth) {
      if ( uid && token ) {
        if (firstLogin === 'true') {
          next({
            path: '/firstLogin',
          })
        } else {
          store.dispatch('getCurrentPageName', to.name)
          next()
        }
      }
      else {
        next({
          path: '/login',
          query: {redirect: to.fullPath}
        })
      }
    } else {
      store.dispatch('getCurrentPageName', to.name)
      next()
    }
  }
})

export default router
